import React, {useContext} from "react"
import {Text, View} from "@react-pdf/renderer"
import {baseStyles} from "../styles"
import {Pill, PillDivider} from "../PDFPrimitives"
import {PDFContext} from "../BasePDF"

// Dealer-only variant: Term gets its own pill in the strip; Lender moves
// to a dedicated full-width row below the strip.
export const DealerVehicleInfoPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    const car      = pdfData.car_detail
    const location = pdfData.location

    const titleParts = [car.year, car.make, car.model].filter(Boolean).join(' ')
    const specParts  = [
        car.style_description,
        car.trim,
        car.manufacture_code ? `[${car.manufacture_code}]` : '',
    ].filter(Boolean).join(' · ')

    const typeStr = pdfData.lease_type || '—'
    const termStr = pdfData.term ? `${pdfData.term} mo` : '—'
    const msrpStr = pdfData.msrp ? pdfData.msrp.toDollarFormat() : '—'

    const lenderValue =
        String(pdfData?.program_description || '')
            .replace(/\([^)]*\)/g, '')
            .replace(/\s{2,}/g, ' ')
            .trim()
        || pdfData.lender_name
        || '—'

    return (
        <>
            <View style={baseStyles.vehicleInfoRow}>
                <View style={[baseStyles.vehicleNameBlock, {maxWidth: 300}]}>
                    <Text style={baseStyles.vehicleName}>{titleParts}</Text>
                    {specParts.length > 0 && (
                        <Text style={baseStyles.vehicleSpec}>{specParts}</Text>
                    )}
                </View>

                <View style={baseStyles.pillContainer}>
                    <Pill label="Type"   value={typeStr}/>
                    <PillDivider/>
                    <Pill label="Term"   value={termStr}/>
                    <PillDivider/>
                    <Pill label="MSRP"   value={msrpStr}/>
                    <PillDivider/>
                    <Pill label="State"  value={location?.state  || '—'}/>
                    <PillDivider/>
                    <Pill label="County" value={location?.county || '—'}/>
                </View>
            </View>

            <View style={baseStyles.viLenderRow}>
                <Text style={baseStyles.viLenderLabel}>Lender:</Text>
                <Text style={baseStyles.viLenderValue}>{lenderValue}</Text>
            </View>
        </>
    )
}
